/* Green Hills Coffee USA — product page interactions
   Variant selection · gallery · purchase mode · qty · live price */
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('[data-gh-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var subDiscount = parseFloat(root.getAttribute('data-sub-discount') || '0') / 100;

    var idInput = root.querySelector('[data-gh-variant-id]');
    var planInput = root.querySelector('[data-gh-selling-plan]');
    var priceNow = root.querySelector('[data-gh-price-now]');
    var priceWas = root.querySelector('[data-gh-price-was]');
    var priceSave = root.querySelector('[data-gh-price-save]');
    var atc = root.querySelector('[data-gh-atc]');
    var atcLabel = root.querySelector('[data-gh-atc-label]');
    var qtyInput = root.querySelector('[data-gh-qty-input]');
    var subPriceEls = root.querySelectorAll('[data-gh-sub-price]');
    var oneTimePriceEls = root.querySelectorAll('[data-gh-onetime-price]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-gh-optgroup]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v['option' + (i + 1)] === o; });
      });
    }

    function isSubscribe() {
      var sub = root.querySelector('[data-gh-mode="subscribe"] input:checked');
      return !!sub;
    }

    function currentQty() {
      return Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    }

    function render() {
      var v = findVariant(selectedOptions()) || variants.find(function (x) { return x.available; }) || variants[0];
      if (!v) return;

      if (idInput) idInput.value = v.id;

      var sub = isSubscribe();
      var unit = v.price;
      var subUnit = Math.round(v.price * (1 - subDiscount));

      // selling plan id binding
      if (planInput) {
        if (sub) {
          var planId = root.getAttribute('data-gh-default-plan') || '';
          planInput.value = planId;
          planInput.disabled = !planId;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }

      // per-mode price labels
      oneTimePriceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });
      subPriceEls.forEach(function (el) { el.textContent = formatMoney(subUnit); });

      // main price block
      var shown = sub ? subUnit : unit;
      if (priceNow) priceNow.textContent = formatMoney(shown);
      var onSale = !!v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) {
        priceWas.textContent = onSale ? formatMoney(v.compare_at_price) : '';
        priceWas.hidden = !onSale;
      }
      if (priceSave) {
        // A discount that rounds to 0% gets no badge
        var pct = onSale ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) : 0;
        priceSave.textContent = pct >= 1 ? 'Save ' + pct + '%' : '';
        priceSave.hidden = pct < 1;
      }

      // availability + ATC
      var qty = currentQty();
      if (atc) {
        if (v.available) {
          atc.disabled = false;
          if (atcLabel) atcLabel.textContent = 'Add to cart · ' + formatMoney(shown * qty);
        } else {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Sold out';
        }
      }
    }

    // Option swatches (label-wrapped radios)
    root.querySelectorAll('[data-gh-optgroup] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var group = input.closest('[data-gh-optgroup]');
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-active'); });
        var lbl = input.closest('.swatch');
        if (lbl) lbl.classList.add('is-active');
        render();
      });
    });

    // Purchase mode
    root.querySelectorAll('[data-gh-mode] input').forEach(function (input) {
      input.addEventListener('change', function () {
        root.querySelectorAll('[data-gh-mode]').forEach(function (m) { m.classList.remove('is-active'); });
        var opt = input.closest('[data-gh-mode]');
        if (opt) opt.classList.add('is-active');
        render();
      });
    });

    // Qty stepper
    var minus = root.querySelector('[data-gh-qty-minus]');
    var plus = root.querySelector('[data-gh-qty-plus]');
    var qVal = root.querySelector('[data-gh-qty-val]');
    function setQty(n) {
      n = Math.max(1, n);
      if (qtyInput) qtyInput.value = n;
      if (qVal) qVal.textContent = n;
      render();
    }
    if (minus) minus.addEventListener('click', function () { setQty(currentQty() - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(currentQty() + 1); });

    // Gallery thumbs
    var mainImg = root.querySelector('[data-gh-gallery-main]');
    root.querySelectorAll('[data-gh-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-gh-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (mainImg && btn.dataset.src) {
          mainImg.src = btn.dataset.src;
          var contain = btn.dataset.contain === 'true';
          mainImg.style.width = contain ? '74%' : '100%';
          mainImg.style.height = contain ? 'auto' : '100%';
          mainImg.style.objectFit = contain ? 'contain' : 'cover';
        }
      });
    });

    /* ---- Add to cart → AJAX + success dialog ---- */
    var form = root.querySelector('.pdp__form');
    var modal = root.querySelector('[data-gh-modal]');
    if (form && modal) {
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      var openModal = function () {
        modal.hidden = false;
        document.body.classList.add('gh-no-scroll');
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
      };
      var closeModal = function () {
        modal.classList.remove('is-open');
        document.body.classList.remove('gh-no-scroll');
        setTimeout(function () { modal.hidden = true; }, 250);
      };
      modal.querySelectorAll('[data-gh-modal-close]').forEach(function (b) {
        b.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

      var updateCount = function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            });
          }).catch(function () {});
      };

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atc = form.querySelector('[data-gh-atc]');
        if (atc && atc.disabled) return;
        if (atc) atc.disabled = true;
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        }).then(function (r) { return r.json(); })
          .then(function (item) {
            if (atc) atc.disabled = false;
            if (!item || !item.id) { form.submit(); return; }
            var img = modal.querySelector('[data-gh-added-img]');
            if (img && item.image) img.src = item.image;
            var title = modal.querySelector('[data-gh-added-title]');
            if (title) title.textContent = item.product_title || item.title;
            var variant = modal.querySelector('[data-gh-added-variant]');
            if (variant) variant.textContent = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? item.variant_title : '';
            var price = modal.querySelector('[data-gh-added-price]');
            if (price) price.textContent = formatMoney(item.final_line_price != null ? item.final_line_price : item.price);
            updateCount();
            openModal();
          }).catch(function () {
            if (atc) atc.disabled = false;
            form.submit();
          });
      });
    }

    render();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    document.querySelectorAll('[data-gh-product]').forEach(init);
  });
})();
